import { render, staticRenderFns } from "./form-input1_varidation.vue?vue&type=template&id=a0c0aff2&scoped=true&"
import script from "./form-input1_varidation.vue?vue&type=script&lang=js&"
export * from "./form-input1_varidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c0aff2",
  null
  
)

export default component.exports